var ListEducation = [
    {
        "name": "Alterra Academy",
        "period": "March - July 2020",
        "description": "Alterra Academy is a coding bootcamp for everyone even non IT background. In this program, I learn how to make a software or website within 3 months.",
        "title": "Fullstack Engineer Trainee",
        "url": "https://academy.alterra.id/",
    },
    {
        "name": "Institut Teknologi Sepuluh Nopember",
        "period": "August 2015 - August 2019",
        "description": "lorem ipsum",
        "title": "Bachelor of Electrical Engineering",
        "url": "https://www.its.ac.id/",
    },
]

export default ListEducation;


// WEBPACK FOOTER //
// ./src/data/Education.js